import React, {useEffect, useState} from 'react'

export function CircularProgress({
  children,
  value = 0,
  size = 60,
  strokeWidth = 6,
  strokeColor = '#3ED06A',
  animate = false
}) {
  const [animatedValue, setAnimatedValue] = useState(animate ? value : 0)

  useEffect(() => {
    if (animate) {
      setAnimatedValue(value)
      return
    }

    let start = null
    const duration = 600
    const from = animatedValue
    const to = value

    const step = (timestamp) => {
      if (!start) start = timestamp
      const progress = timestamp - start
      const percent = Math.min(progress / duration, 1)
      const current = Math.round(from + (to - from) * percent)
      setAnimatedValue(current)

      if (percent < 1)
        requestAnimationFrame(step)
    }

    requestAnimationFrame(step)
  }, [value])

  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (animatedValue / 100) * circumference

  const center = size / 2
  const textSize = size * (1 / 6) + 4

  return (
    <div>
      <div style={{position: 'relative', width: size, height: size}}>
        <svg width={size} height={size}>
          <circle
            stroke="#222833"
            fill="none"
            cx={center}
            cy={center}
            r={radius}
            strokeWidth={strokeWidth}
          />
          <circle
            stroke={strokeColor}
            fill="none"
            cx={center}
            cy={center}
            r={radius}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform={`rotate(-90 ${center} ${center})`}
            style={animate ? {transition: 'stroke-dashoffset 0.6s ease'} : {}}
          />
        </svg>

        <div style={{
          position: 'absolute',
          top: 0, left: 0,
          width: '100%', height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: textSize,
          fontWeight: 'bold',
          textAlign: 'center',
          overflow: 'hidden',
          borderRadius: '50%'
        }}>
          {children ?? `${animatedValue}%`}
        </div>
      </div>
      {
        children &&
        <div style={{
          color: '#575F71',
          marginTop: 8,
          textAlign: 'center',
          fontSize: textSize,
          fontWeight: 'bold'
        }}>
          {`${value}%`}
        </div>
      }
    </div>
  )
}